<template>
  <el-dialog
    :visible.sync="centerDialogVisible"
    custom-class="message_box"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :show-close="icon === 'warning' || showClose?true:false"
    center
    :class="confirmText ? 'confirm-text-dialog__footer' : ''"
  >
    <div class="message_box_icon">
      <i
        v-if="icon === 'success'"
        class="el-icon-success"
        style="color: #008b40"
      ></i>
      <div v-if="icon === 'warning'">
        <i
          v-if="severity === 'low'"
          class="el-icon-warning"
          style="color: #00b1ff"
        ></i>
        <i
          v-if="severity === 'medium'"
          class="el-icon-warning"
          style="color: #f5bb4a"
        ></i>
        <i
          v-if="severity === 'high'"
          class="el-icon-warning"
          style="color: #e40030"
        ></i>
      </div>
      <i
        v-if="icon === 'error'"
        class="el-icon-error"
        style="color: #e40030"
      ></i>
    </div>
    <div class="message_box_title" v-html="title"></div>
    <div class="message_box_confirm_title" v-html="confirmTitle"></div>
    <template
      v-for="(item, index) in list"
      v-html="list"
      class="message_box_content"
    >
      <div class="message_box_content" :key="index">
        <div class="content_title">{{ item.title }}</div>
        <div class="message_content_icon">
          <i
            v-if="item.level === 'success'"
            class="el-icon-success"
            style="color: #008b40"
          ></i>
          <div v-if="item.level === 'warn'">
            <i
              v-if="severity === 'low'"
              class="el-icon-warning"
              style="color: #00b1ff"
            ></i>
            <i
              v-if="severity === 'medium'"
              class="el-icon-warning"
              style="color: #f5bb4a"
            ></i>
            <i
              v-if="severity === 'high'"
              class="el-icon-warning"
              style="color: #e40030"
            ></i>
          </div>
          <i
            v-if="icon === 'error'"
            class="el-icon-error"
            style="color: #e40030"
          ></i>
        </div>
      </div>
    </template>

    <div class="message_box_sub_Title" v-html="subTitle"></div>
    <div class="message_box_confirm_Text" v-html="confirmText"></div>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-if="showCancel"
        class="message_box_btn"
        @click="cancel"
        :disabled="disabled"
      >
        {{ $t('btn.cancel') }}
      </el-button>
      <el-button
        class="message_box_btn"
        type="primary"
        @click="confirm"
        :disabled="disabled"
      >
        {{ btnText }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Index',
  props: {
    icon: {
      type: String
    },
    severity: {
      type: String,
      default: 'medium'
    },
    title: {
      type: String,
      require: true
    },
    subTitle: {
      type: String
    },
    btnText: {
      type: String,
      default: 'Confirm'
    },
    callBack: {
      type: Function,
      default: function(event) {
        this.default.methods.close();
      }.bind(this)
    },
    cancelCallBack: {
      type: Function,
      default: function(event) {
        this.default.methods.close();
      }.bind(this)
    },
    onClose: {
      type: Function,
      default: function(event) {
        this.default.methods.close();
      }.bind(this)
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    autoConfirm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      centerDialogVisible: false,
      disabled: false
    };
  },
  methods: {
    async confirm() {
      this.disabled = true;
      if (this.callBack) {
        await this.$awaitWrap(this.callBack());
      }
      this.close();
    },
    async cancel() {
      this.disabled = true;
      if (this.cancelCallBack) {
        await this.$awaitWrap(this.cancelCallBack());
      }
      this.close();
    },
    async handleClose() {
      this.disabled = true;
      if (this.onClose) {
        await this.$awaitWrap(this.onClose());
      }
      this.close();
    },
    close() {
      this.centerDialogVisible = false;
      this.disabled = false;
    }
  }
};
</script>

<style lang="less">
.message_box_icon,
.message_box_title,
.message_box_sub_Title {
  text-align: center;
  max-height: 400px;
  overflow: auto;
}

.message_box_icon {
  font-size: 60px;
}

.message_content_icon {
  font-size: 16px;
}

.message_box_title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-top: 20px;
  word-break: break-word;
  //   word-break: keep-all;
}

.message_box_content {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-top: 20px;
  word-break: keep-all;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  .content_title {
    width: 220px;
  }
}

.message_box_sub_Title {
  font-size: 14px;
  font-weight: 400;
  color: #999;
  margin-top: 20px;
  word-break: keep-all;
}

.message_box_confirm_Text {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-top: 20px;
  word-break: keep-all;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  .content_title {
    width: 200px;
  }
}

.message_box {
  border-radius: 10px;
  width: 450px !important;

  .el-dialog__headerbtn {
    width: 20px;
    height: 20px;
    background: #efeeee;
    border-radius: 50%;

    .el-dialog__close {
      color: #fff;
    }
  }

  .el-dialog__footer {
    margin-top: 50px;

    .message_box_btn {
      height: 32px;
      line-height: 32px;
      padding: 0 15px;
    }
  }


}

.no-color-btn {
}

.confirm-text-dialog__footer {
  .el-dialog__footer {
    margin-top: 0 !important;
  }
}

.row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;

  .content {
    width: 200px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?ff7b2390